import { render, staticRenderFns } from "./CustomerRegister.vue?vue&type=template&id=18cc0f98&scoped=true"
import script from "./CustomerRegister.vue?vue&type=script&lang=js"
export * from "./CustomerRegister.vue?vue&type=script&lang=js"
import style0 from "./CustomerRegister.vue?vue&type=style&index=0&id=18cc0f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cc0f98",
  null
  
)

export default component.exports